import axiosInstance from "../../../api/axiosInstance";

let getusers = async(prop) => {
    return new Promise((resolve, reject) => {   
        axiosInstance.get(process.env.REACT_APP_API + "/users/get").then(response=> {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    })
}

let getroles = async(prop) => {
    return new Promise((resolve, reject) => {   
        axiosInstance.get(process.env.REACT_APP_API + "/users/roles").then(response=> {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    })
}

export {
    getusers,
    getroles
}
